import { render, staticRenderFns } from "./TicketEditForm.vue?vue&type=template&id=536e2bb4&"
import script from "./TicketEditForm.vue?vue&type=script&lang=js&"
export * from "./TicketEditForm.vue?vue&type=script&lang=js&"
import style0 from "./TicketEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports